import React from 'react';
import { lang } from '@umu/ukit-lang';
import { PreImg } from 'common/src/components';
import { getMedalIcon } from '@umu/umu-util';
import iconMedal from './images/icon-medal.png';
import './userMedal.scss';

// const MEDAL_DESC_LIST: {
//     [index: number]: string;
// } = {
//     1: lang('恭喜你，{$medalRemark}，点亮了“{$medalTitle}”勋章！继续{$medalAction}就可以持续升级勋章。'),
//     2: lang('恭喜你，{$medalRemark}，“{$medalTitle}”勋章已升级！继续{$medalAction}就可以解锁最高级勋章。'),
//     3: lang('恭喜你，{$medalRemark}，“{$medalTitle}”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
// };
const medalTypes: {
    [index: number]: any;
} = {
    100: {
        des: {
            1: lang('恭喜你，获得无限学员特权，点亮了“成长之路”勋章！继续积累UP值就可以持续升级勋章。'),
            2: lang('恭喜你，获得视频上传特权，“成长之路”勋章已升级！继续积累UP值就可以解锁最高级勋章。'),
            3: lang('恭喜你，获得双向会议特权，“成长之路”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('UP值升至第11级'),
            2: lang('UP值升至第21级'),
            3: lang('UP值升至满级'),
        },
    },

    101: {
        des: {
            1: lang('恭喜你，点亮了“一呼百应”勋章！继续邀请好友注册就可以持续升级勋章。'),
            2: lang('恭喜你，“一呼百应”勋章已升级！继续邀请好友注册就可以解锁最高级勋章。'),
            3: lang('恭喜你，“一呼百应”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('邀请10位好友注册'),
            2: lang('邀请100位好友注册'),
            3: lang('邀请1000位好友注册'),
        },
    },

    102: {
        des: {
            1: lang('恭喜你，点亮了“人生赢家”勋章！继续消费就可以持续升级勋章。'),
            2: lang('恭喜你，“人生赢家”勋章已升级！继续消费就可以解锁最高级勋章。'),
            3: lang('恭喜你，“人生赢家”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('累计消费100元'),
            2: lang('累计消费1000元'),
            3: lang('累计消费10000元'),
        },
    },

    200: {
        des: {
            1: lang('恭喜你，点亮了“名师之路”勋章！继续影响学员就可以持续升级勋章。'),
            2: lang('恭喜你，“名师之路”勋章已升级！继续影响学员就可以解锁最高级勋章。'),
            3: lang('恭喜你，“名师之路”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('影响1000位学员'),
            2: lang('影响10000位学员'),
            3: lang('影响100000位学员'),
        },
    },

    201: {
        des: {
            1: lang('恭喜你，点亮了“实力的证明”勋章！继续影响学员就可以持续升级勋章。'),
            2: lang('恭喜你，“实力的证明”勋章已升级！继续影响学员就可以解锁最高级勋章。'),
            3: lang('恭喜你，“实力的证明”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('影响10000次学员'),
            2: lang('影响100000次学员'),
            3: lang('影响1000000次学员'),
        },
    },

    202: {
        des: {
            1: lang('恭喜你，点亮了“聚沙成塔”勋章！继续创建小节就可以持续升级勋章。'),
            2: lang('恭喜你，“聚沙成塔”勋章已升级！继续创建小节就可以解锁最高级勋章。'),
            3: lang('恭喜你，“聚沙成塔”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('创建10个有效小节'),
            2: lang('创建100个有效小节'),
            3: lang('创建1000个有效小节'),
        },
    },

    203: {
        des: {
            1: lang('恭喜你，点亮了“众星捧月”勋章！继续获得好评就可以持续升级勋章。'),
            2: lang('恭喜你，“众星捧月”勋章已升级！继续获得好评就可以解锁最高级勋章。'),
            3: lang('恭喜你，“众星捧月”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('你的课程获得100个好评'),
            2: lang('你的课程获得1000个好评'),
            3: lang('你的课程获得10000个好评'),
        },
    },

    204: {
        des: {
            1: lang('恭喜你，点亮了“赞不绝口”勋章！继续获赞就可以持续升级勋章。'),
            2: lang('恭喜你，“赞不绝口”勋章已升级！继续获赞就可以解锁最高级勋章。'),
            3: lang('恭喜你，“赞不绝口”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('你的课程获得100个赞'),
            2: lang('你的课程获得1000个赞'),
            3: lang('你的课程获得10000个赞'),
        },
    },

    300: {
        des: {
            1: lang('恭喜你，点亮了“神助攻”勋章！继续点赞就可以持续升级勋章。'),
            2: lang('恭喜你，“神助攻”勋章已升级！继续点赞就可以解锁最高级勋章。'),
            3: lang('恭喜你，“神助攻”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('送出100个赞'),
            2: lang('送出1000个赞'),
            3: lang('送出10000个赞'),
        },
    },
    301: {
        des: {
            1: lang('恭喜你，点亮了“言之有物”勋章！继续发言就可以持续升级勋章。'),
            2: lang('恭喜你，“言之有物”勋章已升级！继续发言就可以解锁最高级勋章。'),
            3: lang('恭喜你，“言之有物”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('累计发言100条'),
            2: lang('累计发言1000条'),
            3: lang('累计发言10000条'),
        },
    },

    302: {
        des: {
            1: lang('恭喜你，点亮了“念念不忘”勋章！继续学习就可以持续升级勋章。'),
            2: lang('恭喜你，“念念不忘”勋章已升级！继续学习就可以解锁最高级勋章。'),
            3: lang('恭喜你，“念念不忘”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('在线学习1000分钟'),
            2: lang('在线学习10000分钟'),
            3: lang('在线学习100000分钟'),
        },
    },

    303: {
        des: {
            1: lang('恭喜你，点亮了“人见人爱”勋章！继续获赞就可以持续升级勋章。'),
            2: lang('恭喜你，“人见人爱”勋章已升级！继续获赞就可以解锁最高级勋章。'),
            3: lang('恭喜你，“人见人爱”勋章已升至最高级！高处不胜寒，还有更多成就等待你来解锁。'),
        },
        title: {
            1: lang('你的发言获得100个赞'),
            2: lang('你的发言获得1000个赞'),
            3: lang('你的发言获得10000个赞'),
        },
    },
};
interface IProps {
    // data: any;
    medalId: string;
    type: string;
    rank: string;
    medalTitle: string;
    medalRemark: string;
    points: string;
    medalAction: string;
    onClose: () => void;
}

export default class UserMedal extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.onClose = this.onClose.bind(this);
    }

    public onClose(evt: React.MouseEvent<HTMLAnchorElement>) {
        evt.preventDefault();
        evt.stopPropagation();

        this.props.onClose();
    }

    public render() {
        const {
            medalId,
            type,
            rank,
            medalTitle,
            // medalRemark,
            points,
            // medalAction,
        } = this.props;

        // const medalDesc: { [propName: number]: string } = MEDAL_DESC_LIST[Number(rank)]
        //     .replace('{$medalRemark}', medalRemark)
        //     .replace('{$medalTitle}', medalTitle)
        //     .replace('{$medalAction}', medalAction);
        let medalDesc = medalTypes[Number(type)].des;
        medalDesc = medalDesc[Number(rank)];
        let medalRemark = medalTypes[Number(type)].title;
        medalRemark = medalRemark[Number(rank)];
        const medalIcon = getMedalIcon(type, rank);

        return (
            <div className="user-medal-dialog">
                <a className="close" href="#" onClick={this.onClose}></a>
                <div className="user-medal-preview">
                    <div className="img">
                        <PreImg>
                            <img src={medalIcon} alt="" />
                        </PreImg>
                    </div>
                </div>
                <div className="user-medal-card">
                    <div className="title">{medalTitle}</div>
                    <div className="medal-remark">{medalRemark}</div>
                    <div className="points">
                        <PreImg>
                            <img className="medal-icon" src={iconMedal} alt="" />
                        </PreImg>{' '}
                        {lang('UP值')} <span className="highlight">+{points}</span>
                    </div>
                    <div className="desc">{medalDesc}</div>
                    <div className="actions">
                        <div className="action">
                            <a
                                onClick={this.onClose}
                                href={'/profile/medal#/detail/' + (medalId || 0) + '/type/' + type + '/self/1'}
                                className="btn alias-striking type-primary btn-secondary"
                            >
                                {lang('查看勋章')}
                            </a>
                        </div>
                        <div className="action">
                            <a
                                onClick={this.onClose}
                                href={'/profile/medal#/share/' + (medalId || 0)}
                                className="btn alias-plain type-primary btn-primary"
                            >
                                {lang('分享')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
